import React, { memo } from "react"
import ModalComponent from "components/EvtKit/modal/ModalV2"
import styled from "styled-components"
import Heading from "components/Typography/Heading"
const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: 0 auto;
  padding: 0px 24px;

  &.without-margin {
    margin: 0;
  }
`
const ContainerTitle = styled.div`
  margin-bottom: 24px;
`

interface CustomModalProps {
  className?: string
  openModal: boolean
  closeModal: () => void
  size?: "2-lg" | "sm" | "md" | "1-lg" | "3-lg"
  children: React.ReactNode
  type: "" | "create" | "update" | "delete"
  handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void
  createModalTitle: string
  updateModalTitle: string
}
const CustomModalComponent = (props: CustomModalProps) => {
  const { className, openModal, closeModal, size, children, type, updateModalTitle, createModalTitle } = props

  return (
    <ModalComponent className={className} openModal={openModal} closeModal={closeModal} size={size}>
      <Container className={className}>
        <ContainerTitle>
          <Heading variant="h4" color="primary-dark">
            {type === "create" ? createModalTitle : updateModalTitle}
          </Heading>
        </ContainerTitle>
        {children}
      </Container>
    </ModalComponent>
  )
}

export default memo(CustomModalComponent)
